import {
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router";
 import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Alert,
  AlertTitle,
  SelectChangeEvent,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  TextField,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { requestID, baseUrl, getToken } from "../../common/utils";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ellipsisHorizontalCircle } from "ionicons/icons";
import { useBusinessContext } from "../../context/business-context";
import "./CashWithdrawal.css";

// Custom styled components with consistent color scheme
const StatsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '20px',
  marginBottom: '30px',
  padding: '0 16px',
}));

const StatCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
  },
}));

const StatTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  color: '#6b7280',
  marginBottom: '10px',
  fontWeight: '500',
}));

const StatValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.8rem',
  fontWeight: '700',
  color: '#4361ee',
}));

const ContentCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '25px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  margin: '16px',
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.3rem',
  fontWeight: '600',
  marginBottom: '20px',
  color: '#1e3a8a',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  paddingBottom: '10px',
  borderBottom: '2px solid #f3f4f6',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1e3a8a',
    color: '#ffffff',
    fontWeight: '600',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fafc',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    backgroundColor: '#f1f5f9',
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#4361ee',
  '&:hover': {
    backgroundColor: '#3730a3',
  },
  '&.Mui-disabled': {
    backgroundColor: '#d1d5db',
  },
}));

const CashWithdrawal = () => {
  const { selectedBusiness, isLoading } = useBusinessContext();
  console.log("selected business", selectedBusiness)
  if (isLoading) {
    return <div>Loading</div>
  } 
  
  const { name } = useParams<{ name: string }>();
  const history = useHistory();

  const [ledgetType, setLedgetType] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [ledgerMother, setLedgerMother] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [noticePeriod, setNoticePeriod] = useState("");
  const [message, setMessage] = useState("");
  const [showme, setShowme] = useState(true);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [allLedger, setAllLedger] = useState([]);
  const [checkTeller, setcheckTeller] = useState<Boolean>(false);
  const [modalOpen, setModalOpen] = useState<Boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [actionType, setActionType] = useState<"update" | "reject" | null>(
    null
  );

  // Stats data for the header cards
  const statsData = [
    { title: "Total Members", value: "#11147" },
    { title: "Total Share Capital", value: "N0.0" },
    { title: "Total Saving", value: "N0.0" },
    { title: "No. Of Active Loans", value: "#0" },
    { title: "Outstanding Loans", value: "N0.0" },
    { title: "UniFied Wallet", value: "N0.0" },
    { title: "Pending Approval(s)", value: "#3" }
  ];

  // Helper function to get fresh config with current token
  const getFreshConfig = () => {
    const token = getToken();
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "multipart/form-data",
      },
    };
  };

  const checkTellerx = () => {
    checkTeller ? setcheckTeller(false) : setcheckTeller(true);
    console.log(checkTeller);
  };

  const approve = async (user_id, wid) => {
    const token = getToken();
    if (!token) {
      setErrorLogin("Please login again");
      callToast();
      return;
    }

    console.log(user_id);
    console.log(wid);
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("withdrawalID", wid);
      formData.append("user_id", user_id);
      const response = await axios.post(
        baseUrl() + "withdrawals/W_Approval1",
        formData,
        getFreshConfig() // Use fresh config
      );
      console.log(formData);
      console.log(response);
      if (response.data.status === true) {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: false });
        getLedgers();
      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: true });
      }
    } catch (error) {
      console.error("Approval error:", error);
      setStatus({ loading: false, error: true });
      setErrorLogin("Error approving withdrawal");
      callToast();
    }
  };

  const onUpdateNoticePeriod = async (
    withdrawal_id: string,
    noticePeriod: string
  ) => {
    const token = getToken();
    if (!token) {
      setErrorLogin("Please login again");
      callToast();
      return;
    }

    if (!selectedBusiness || !selectedBusiness.business_id) {
      setErrorLogin("Business context is missing");
      callToast();
      return;
    }

    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("withdrawalID", withdrawal_id);
      formData.append("noticePeriod", noticePeriod);
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "withdrawals/updateNoticePeriod_caas",
        formData,
        getFreshConfig() // Use fresh config
      );
      console.log(response);
      const data = await response.data;
      if (data.status === true) {
        setStatus({ loading: false, error: false });
        setAlertMsg(response.data.message);
        onShowAlert();
        setNoticePeriod("");
        getLedgers();
      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: true });
      }
      getLedgers();
    } catch (error) {
      console.error("Error updating notice period:", error);
      setStatus({ loading: false, error: true });
      setErrorLogin("Error updating notice period");
      callToast();
    }
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 10000);
  };

  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const getLedgers = () => {
    const token = getToken();
    if (!token) {
      setErrorLogin("Please login again");
      callToast();
      return;
    }

    if (!selectedBusiness || !selectedBusiness.business_id) {
      setErrorLogin("Business context is missing");
      callToast();
      return;
    }

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusiness.business_id);
    formData.append("branch_id", selectedBusiness.branch_id);
    
    setStatus({ loading: true, error: false });
    
    axios
      .post(
        baseUrl() + "withdrawals/getAllWithdrawalApplication_caas",
        formData,
        getFreshConfig() // Use fresh config
      )
      .then((response) => {
        console.log("Withdrawals response:", response);
        console.log(response.data.data);
        setAllLedger(response.data.data || []);
        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        console.error("Error fetching withdrawals:", error);
        setStatus({ loading: false, error: true });
        setErrorLogin("Failed to load withdrawal data");
        callToast();
      });
  };

  const rows = allLedger;
  const handleOpenDialog = (userId: string, action: "update" | "reject") => {
    setSelectedUserId(userId);
    setActionType(action);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUserId(null);
    setActionType(null);
  };

  const handleConfirmAction = () => {
    if (actionType && selectedUserId && noticePeriod) {
      if (actionType === "update") {
        onUpdateNoticePeriod(selectedUserId, noticePeriod);
      } else if (actionType === "reject") {
        handleCloseDialog();
      }
      handleCloseDialog();
    }
  };

  useIonViewWillEnter(() => {
    const token = getToken();
    if (!token) {
      setErrorLogin("Please login again");
      callToast();
      return;
    }

    if (!selectedBusiness || !selectedBusiness.business_id) {
      setErrorLogin("Please select a business first");
      callToast();
      return;
    }

    getLedgers();
  }, [selectedBusiness]);

  return (
    <IonPage className="cash-withdrawal-page">
      <IonHeader>
        <IonToolbar className="cash-withdrawal-header">
          <IonButtons slot="start">
            <IonMenuButton className="menu-button" />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="cash-withdrawal-content">
        <IonHeader collapse="condense">
          <IonToolbar className="cash-withdrawal-header">
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        
        {/* Stats Cards */}
        <StatsContainer>
          {statsData.map((stat, index) => (
            <StatCard key={index}>
              <StatTitle>{stat.title}</StatTitle>
              <StatValue>{stat.value}</StatValue>
            </StatCard>
          ))}
        </StatsContainer>
        
        {showAlert && (
          <Alert severity={status.error ? "error" : "success"} className="alert-message">
            <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}
          </Alert>
        )}

        <ContentCard>
          <CardTitle>
            <IonIcon icon={ellipsisHorizontalCircle} />
            Withdrawal Applications
          </CardTitle>

          {status.loading && allLedger.length === 0 && (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px" className="loading-container">
              <CircularProgress />
              <Typography variant="body2" sx={{ ml: 2 }}>
                Loading withdrawal applications...
              </Typography>
            </Box>
          )}

          {!status.loading && allLedger.length === 0 && (
            <Box textAlign="center" py={4} className="empty-state">
              <Typography variant="h6" color="textSecondary">
                No withdrawal applications found
              </Typography>
            </Box>
          )}

          {allLedger.length > 0 && (
            <Table sx={{ minWidth: 700 }} aria-label="customized table" className="withdrawal-table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell align="right">Amount</StyledTableCell>
                  <StyledTableCell align="right">
                    Days Remaining&nbsp;
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    Date Requested&nbsp;
                  </StyledTableCell>
                  <StyledTableCell align="right">Approval&nbsp;</StyledTableCell>
                  <StyledTableCell align="right">Actions&nbsp;</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map(
                  (row) =>
                    row.status === "0" && (
                      <StyledTableRow key={row.id}>
                        <StyledTableCell align="left">{row.id}</StyledTableCell>
                        <StyledTableCell align="left">{row.uname}</StyledTableCell>
                        <StyledTableCell align="left">{row.amount}</StyledTableCell>
                        <StyledTableCell align="right">
                          {row.days_remaining}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.created_at}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.days_remaining === "0" ? (
                            <CustomButton
                              variant="contained"
                              id={row.id}
                              sx={{ mt: 2 }}
                              onClick={() =>
                                approve(row?.user_id, row?.withdrawal_id)
                              }
                              disabled={status.loading}
                            >
                              {status.loading ? <CircularProgress size={24} /> : "Approve"}
                            </CustomButton>
                          ) : (
                            <Button variant="contained" disabled>
                              Disabled
                            </Button>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          <IonIcon
                            onClick={() =>
                              handleOpenDialog(row?.withdrawal_id, "update")
                            }
                            size="large"
                            icon={ellipsisHorizontalCircle}
                            className="action-icon"
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                )}
              </TableBody>
            </Table>
          )}
        </ContentCard>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
          className="custom-dialog"
        >
          <DialogTitle id="confirmation-dialog-title" className="dialog-header">
            Confirm Action
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ mt: 2 }}>
              Are you sure you want to {actionType} this Cash Withdrawal Notice Period?
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "90%",
                marginTop: "1%",
                "& > :not(style)": { m: 4 },
              }}
            >
              <FormControl fullWidth>
                <TextField
                  required
                  fullWidth
                  type="number"
                  label="Enter Notice Period"
                  margin="normal"
                  value={noticePeriod}
                  onChange={(e) => setNoticePeriod(e.target.value)}
                  className="form-input"
                />
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions className="dialog-actions">
            <CustomButton
              onClick={handleConfirmAction}
              autoFocus
              disabled={status.loading}
            >
              {status.loading ? <CircularProgress size={24} /> : actionType === "update" ? "Update" : "Reject"}
            </CustomButton>
            <Button onClick={handleCloseDialog} color="primary" disabled={status.loading}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <IonLoading
          message="Please wait..."
          spinner="circles"
          isOpen={status.loading}
        />
        {status.error && (
          <IonToast position="bottom" isOpen={showToast} message={errorLogin} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default CashWithdrawal;